export const clinics = '/clinics';
export const clinic = (id: number) => `/clinics/${id}`;
export const doctorClinics = (id: number) => `/clinics/doctor/${id}`;
